import React from 'react';
import PropTypes from 'prop-types';
import TypesContainer from '../TypesContainer';

const NonEditableField = (props) => (
  <div className="row px-3">
    <div className="col mt-2">
      <div className="row mb-4">
        <div className="col-sm-6">
          <TypesContainer
            disabled
            radioGroupName="Field Type"
            keyPath={props.keyPath}
            onFieldValueChange={props.onFieldValueChange}
            values={props.values}
          />

        </div>
        <div className="col-sm-6-mt-4 d-flex align-items-end">
          <p className="mb-0">{props.editorName} field cannot be edited.</p>
        </div>
      </div>
    </div>
  </div>
);

NonEditableField.propTypes = {
  keyPath: PropTypes.array.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  editorName: PropTypes.string.isRequired,
};

export default (editorName) => (props) => <NonEditableField editorName={editorName} {...props} />;
